<template>
  <div>
  
  <!-- start company info header -->
  
  <div style="margin-bottom:90px" @click="goToEntity()">
 	<card style="" >
 		<div style="padding-bottom:10px;">
   		<div style="font-weight:bold;font-size:24px"> {{coy.entity_name}}</div>
   		<div> <span>UEN: </span> {{coy.uen}}</div>
   		</div>
    </card>
  </div>
  
  <!-- end company info header -->
  
  
   <h4 class="title">Select Task</h4>
      <p class="category">
      What do you want to do today?
      </p>
  
            <div class="row">
      <div class="col-lg-6 col-md-12">
        <div>

        </div>
        <card>
          <h5 slot="header" class="card-title">Resolutions</h5>

          <collapse>
            <collapse-item title="Directors' Resolutions" name="1">
              <div>
               <ul slot="raw-content" class="list-group list-group-flush">
               <p-radio v-model="enabledRadio" label="1">Change Of Company Address</p-radio>
               <p-radio v-model="enabledRadio" label="2">Change In Director And Removal Of Member</p-radio>
               <p-radio v-model="enabledRadio" label="3">Appointment Of Secretary</p-radio>
               
           
 
   			</ul>
              </div>
            </collapse-item>
            <collapse-item title="Shareholders' Resolutions" name="2">
              <div>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </collapse-item>
            <collapse-item title="Shares" name="3">
              <div>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </collapse-item>
          </collapse>

        </card>
      </div>


      <div class="col-lg-6 col-md-12">
        <card>
          <h5 slot="header" class="card-title">AGM / EGM</h5>

          <collapse>
            <collapse-item title="Default Collapsible Item 1" name="1">
              <div>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </collapse-item>
            <collapse-item title="Default Collapsible Item 1" name="2">
              <div>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </collapse-item>
            <collapse-item title="Default Collapsible Item 1" name="3">
              <div>
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              </div>
            </collapse-item>
          </collapse>

        </card>
      </div>

    </div>  
            
          
          
   <p-button type="info" @click="goToCreateCustomTask()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Create Custom Task
      </p-button>        
   


  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  
  export default {
    components: {
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {
      	let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.id;
     	 ApiService.get(uri).then(response => {
      	
         	this.coy = response.data.entity;

         	
      	})
    },
    data () {
      return {
        activeName: 'first',
        enabledRadio: '2',
        coy:[]
      }
    },
    methods:{
       goToCreateCustomTask(){
       		 this.$router.push( '/edit-task/0/entity/'+this.$route.params.id);
       },
       goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.id);
	    },
    },
    watch: {
   		enabledRadio: function (){
   			this.$router.push( '/create-task-details/'+ this.$route.params.id+"/ch_address/"+"0/0/create")
        	//alert("changed!"+ this.enabledRadio);
   		}
	}
    
  }
</script>
<style>
</style>
